    <!-- Encabezado con imágen -->
    <div class="breadcaump-area bg_image--13 ptb--270 ptb-md--150 ptb-sm--150 breadcaump-title-bar breadcaump-title-white">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcaump-inner text-center mt_sm--50 mt_md--50">
                        <h1 class="heading heading-h1 text-white">Estás aquí por una razón <br> Tu intuición es correcta.</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="brook-icon-boxes-area space_dec--100 pt_md--80 pt_sm--60">
        <div class="container">
            <div class="row">
                <!-- Start Single Icon Boxes -->
                <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                    <div class="icon-box text-center">
                        <div class="inner">
                            <div class="icon">
                                <i class="ion-ios-eye-outline"></i>
                            </div>
                            <div class="content">
                                <h5 class="heading heading-h5">Inicios</h5>
                                <p class="bk_pra">La Escuela Akashica® fue fundada en el año 2012 por Ana Silvia Lara, Conferencista, Escritora, Instructora, Coach y Consultora.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Single Icon Boxes -->

                <!-- Start Single Icon Boxes -->
                <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                    <div class="icon-box text-center">
                        <div class="inner">
                            <div class="icon">
                                <i class="ion-ios-bookmarks-outline"></i>
                            </div>
                            <div class="content">
                                <h5 class="heading heading-h5">Propósito</h5>
                                <p class="bk_pra">Facilitar a nuestros estudiantes ese reencuentro con lo sagrado que hay en ellos y ayudarles a convertirse en protagonistas de esta transformación de conciencia en la que todo el planeta está implicado.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Single Icon Boxes -->

                <!-- Start Single Icon Boxes -->
                <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                    <div class="icon-box text-center">
                        <div class="inner">
                            <div class="icon">
                                <i class="ion-ios-browsers-outline"></i>
                            </div>
                            <div class="content">
                                <h5 class="heading heading-h5">Objetivo</h5>
                                <p class="bk_pra">Nuestro objetivo es transmitir, practicar y enseñar herramientas de conocimiento, crecimiento personal, inteligencia y conciencia ilimitada aplicada.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Single Icon Boxes -->

            </div>
        </div>
    </div>

